import { FC, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "flowbite-react";
import { useTranslation } from "react-i18next";
import CreateOrder from "../create-order/CreateOrder";
import { useOrderTemplates } from "@data";
import { OrderTemplate } from "../../../models";

/**
 * Loader for editing an existing order template. Resolves the template from
 * the workspace list and renders the wizard in "template mode".
 */
const EditOrderTemplate: FC = () => {
  const { t } = useTranslation(["orders", "common"]);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const templatesQuery = useOrderTemplates();

  const template = useMemo(
    () =>
      (templatesQuery.data ?? []).find(
        (tpl: OrderTemplate) => tpl.id === id,
      ),
    [templatesQuery.data, id],
  );

  if (templatesQuery.isLoading) {
    return (
      <div className="flex items-center justify-center h-full py-10">
        <Spinner />
      </div>
    );
  }

  if (!template) {
    return (
      <div className="flex items-center justify-center h-full py-10">
        <p className="text-muted">{t("templates.not_found")}</p>
      </div>
    );
  }

  return (
    <CreateOrder
      mode="template"
      initialTemplate={template}
      isEdit
      onTemplateSaved={() => navigate("/order-templates")}
    />
  );
};

export default EditOrderTemplate;
